import { createContext, useMemo } from 'react';
import { useSetState } from 'react-use';
import { useFuzzySearchQ } from '../../hooks/useFuzzySearch';
import { defaultTableState, ITableContext, ITableProviderProps, ITableState } from './Table.types';

export const TableContext = createContext<ITableContext>({
  state: defaultTableState,
  config: {} as any,
  patchState: () => {},
  callbacks: {
    onAction: () => {},
  },
  data: [],
});

export const TableProvider = (props: ITableProviderProps) => {
  const { config, data: inData } = props;
  const { misc } = config;
  const { actionType } = misc;

  const [state, patchState] = useSetState<ITableState>({
    ...defaultTableState,
  });

  const { q } = state;

  const callbacks = useMemo(
    () => ({
      onAction: (action: Action) => {
        props.onAction({ ...action, type: actionType });
      },
    }),
    [state, actionType]
  );

  const filteredData = useFuzzySearchQ(inData, ['name'], q);

  const cValue = useMemo(
    () => ({
      state,
      patchState,
      callbacks,
      data: filteredData,
      config,
    }),
    [state, callbacks, filteredData, config]
  );

  return <TableContext.Provider value={cValue}>{props.children}</TableContext.Provider>;
};
